import Const from '@app/config/const';
import createReducer from '@app/config/create_reducer';

type State = {
  show: boolean,
  state: 'waiting' | 'processing' | 'done',
  title?: string,
  subtitle?: string,
  duration?: number,
  amount?: number,
  localAmount?: number,
  closeAfter?: number
};

const defaultState: State = {
  show: false,
  state: 'waiting'
};

const handler = {
  [Const.topup.show]: (state: State, {
    duration, closeAfter, amount, localAmount, title, subtitle
  }: Partial<State>) => ({
    ...state,
    duration,
    closeAfter,
    amount,
    localAmount,
    title,
    subtitle,
    show: true
  }),
  [Const.topup.hide]: () => ({
    ...defaultState
  }),
  [Const.topup.changeState]: (state: State, { state: newState }: Partial<State>) => ({
    ...state,
    state: newState
  })
};

export default createReducer(defaultState, handler);
